import React from 'react'
import {toLower} from 'ramda'
import './flag.scss'

const buildClass = (code) => `flag flag-${toLower(code)}`

export default ({code}) =>
  <span className={buildClass(code)}
  />



// WEBPACK FOOTER //
// ./src/components/flag.js